import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import connection from "../api/config/connection";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import actions from "../actions/dienstregeling";
import scrollTo from "../utils/scrollTo";
import dynamicPortal from "../utils/dynamicPortal";

export class DienstregelingFormPortal extends Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  switchToDirectionId() {
    const form = this.formRef.current;
    const formik = form.formikRef.current;

    formik.setFieldValue("directionId", this.props.switchToDirectionId);
    form.handleSubmitButtonClick();
  }

  componentDidUpdate() {
    if (this.props.switchToDirectionId !== undefined)
      this.switchToDirectionId();
  }

  render() {
    return dynamicPortal.load(".js-react-dienstregeling-form", (config) => {
      config.submit.method = "GET";
      config.submit.async = true;

      return (
        <div className="theme--accent">
          <div className="container container--center container--clearfix">
            <div className="container container--margin">
              <Form
                ref={this.formRef}
                config={config}
                templates={templates}
                axios={connection.instance()}
                onSubmit={async (values) => await this.handleSubmit(values)}
                onSubmitted={async (response, values) =>
                  await this.handleSubmitted(response, values)
                }
                onError={(error) => this.handleError(error)}
              />
            </div>
          </div>
        </div>
      );
    });
  }

  async handleSubmit(values) {
    this.props.requestDienstregeling();
  }

  handleError(error) {
    this.props.failedDienstregeling();
  }

  async handleSubmitted(response, values) {
    if (!response.data) {
      this.props.failedDienstregeling();
      return;
    }
    if (response.data.error) {
      this.props.failedDienstregeling();
      return;
    }

    const dienstregeling = this.convertResponseToDienstregeling(
      response.data,
      values
    );
    this.handleReceivedDienstregeling(dienstregeling);
  }

  handleReceivedDienstregeling(dienstregeling) {
    const form = this.formRef.current;
    const formik = form.formikRef.current;

    this.props.receivedDienstregeling(dienstregeling);

    const resultsElement = document.querySelector(".js-react-dienstregeling");
    if (resultsElement) scrollTo.scrollToElement(resultsElement, -40);

    formik.setFieldValue(
      "directionId",
      this.props.switchToDirectionId === 0 ? 1 : 0
    );
  }

  convertResponseToDienstregeling(data, values) {
    const result = (data && data.result) || {};
    let stops = result.stops;
    const trips = result.trips || [];

    const timetable = trips.map((trip) => {
      return stops.map((stop) => {
        const entry = trip.stops.find(
          (item) =>
            item.quaycode === stop.quaycode &&
            item.distinctIndex === stop.distinctIndex
        );
        if (!entry) {
          return {};
        }
        if (typeof entry.realtime === "undefined") {
          return {
            departure: entry.pt_departure_time || "??:??",
          };
        }
        const origTimeToEpoch = moment(
          values["date"]
            ? `${values["date"]} ${entry.pt_departure_time}`
            : entry.pt_departure_time,
          "DD-MM-YYYY hh:mm:ss"
        ).valueOf();
        const origTime = moment(origTimeToEpoch);
        const realTime = moment.unix(entry.realtime.realtime_departure_time);
        const diffTime = Math.round(
          moment.duration(realTime.diff(origTime)).as("minutes")
        );

        return {
          departure: entry.pt_departure_time || "??:??",
          trip_schedule:
            typeof entry.realtime !== "undefined"
              ? entry.realtime.schedule_relationship
              : null,
          realtime_departure_time:
            typeof diffTime !== undefined &&
            !isNaN(parseFloat(diffTime)) &&
            !isNaN(diffTime - 0)
              ? diffTime
              : 0,
        };
      });
    });

    stops = stops.map((stop) => {
      const quay = stop.quay || {};
      return {
        stopId: quay.stopplacecode,
        quayCode: quay.quaycode,
        disabledAccessible: quay.disabled_accessible || false,
        town: quay.town || "",
        name: quay.name || "",
        location: quay.location,
      };
    });

    const route = result.route || {};
    const route_direction = result.route_direction || {};

    let name = route_direction.headsign;
    const hasOppositeDirection = Object.keys(route_direction).length
      ? route_direction.has_opposite_direction
      : true;
    let lineNumber = route.route_short_name;
    const agencyId = route.agency_id;

    let routeId = "?";
    let directionId = 0;
    let date = null;
    let time = null;
    try {
      if (values["route"]) {
        var valuesRoute =
          (typeof values["route"] === "string"
            ? JSON.parse(values["route"])
            : values["route"]) || {};
        routeId = valuesRoute.route_id;
        lineNumber = lineNumber || valuesRoute.route_short_name;
        name = name || valuesRoute.route_long_name;
      }
      if (values["directionId"]) directionId = values["directionId"];
      if (values["date"]) date = values["date"];
      if (values["time"]) time = values["time"];
    } catch (ex) {}

    const shape_ids = route_direction.shape_ids || [];
    return {
      name,
      hasOppositeDirection,
      lineNumber,
      agencyId,
      stops,
      timetable,
      route,
      routeId,
      directionId,
      date,
      time,
      shape_ids,
    };
  }
}

export default connect(
  ({ dienstregeling }) => ({
    switchToDirectionId: dienstregeling.switchToDirectionId,
  }),
  (dispatch) => {
    return {
      requestDienstregeling: () => dispatch(actions.request()),
      receivedDienstregeling: (dienstregeling) =>
        dispatch(actions.received(dienstregeling)),
      failedDienstregeling: (error) => dispatch(actions.failed(error)),
    };
  }
)(DienstregelingFormPortal);



// WEBPACK FOOTER //
// ./src/portals/DienstregelingFormPortal.js